module.exports = {
      id: "new-label-usage",
      viewBox: "0 0 26 10",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#new-label",
      toString: function () {
        return this.url;
      }
    }